import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap';

const TabContent = ({ sliders, activeText, buttonText, buttonUrl }) => {
  // Find the active slider based on activeText, fallback to first slider or empty object
  const activeSlider = sliders.find((slider) => slider.title === activeText) || sliders[0] || {};

  // Default bullet points as fallback
  const defaultBulletPoints = [
    'Vidyakasam – Smart Exam Prep',
    'MCQs, Notes, Tests & Lectures for All Competitive Exams',
    'Vidyakasam Education is an all-in-one platform for competitive exam preparation.',
  ];

  // Use dynamic description or fallback
  const description = activeSlider.description || 'No description available.';

  // Use dynamic bullet points if provided in JSON, otherwise use default
  const bulletPoints = activeSlider.bullet_points || defaultBulletPoints;

  return (
    <div className="tab-content">
      <h3 className="download-heading">{activeSlider.heading || activeSlider.title || 'No Title'}</h3>
      <div className="content-section">
        <p
          className="mb-0 paragraph-text text-white"
          dangerouslySetInnerHTML={{ __html: description }}
        />
        <Button
          as="a"
          href={buttonUrl}
          className="get-btn get-btn2"
          style={{
            padding: '12px 24px',
            fontSize: '1rem',
            fontWeight: 600,
            textTransform: 'uppercase',
          }}
        >
          {buttonText}
        </Button>
      </div>
    </div>
  );
};

TabContent.propTypes = {
  sliders: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      description: PropTypes.string,
      bullet_points: PropTypes.arrayOf(PropTypes.string),
    })
  ).isRequired,
  activeText: PropTypes.string.isRequired,
  buttonText: PropTypes.string.isRequired,
  buttonUrl: PropTypes.string.isRequired,
};

export default TabContent;